/* ==========================================================================
   VITAL VIAL - Cart
   Quantity changes and removals go through /cart/change.js and re-render the
   section, so nothing full-reloads. Works for both the cart page and the
   cart drawer: on pages without the cart page section (product pages, home,
   etc.) only the drawer re-renders, and it stays open.
   ========================================================================== */
(function () {
  'use strict';

  // The cart page loads this file twice (cart drawer section + cart page
  // section). Run it once only, or every quantity click is handled twice.
  if (window.__vvCartLoaded) return;
  window.__vvCartLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function sectionId() {
    var el = document.querySelector('.vv-cart-section');
    if (!el) return null;
    var m = (el.id || '').match(/shopify-section-(.+)/);
    return m ? m[1] : null;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD'
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function setBusy(row, on) {
    if (row) row.classList.toggle('is-busy', on);
    busy = on;
  }

  function showError(row, msg) {
    var el = row && row.querySelector('[data-vv-cart-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  /* ---- Re-render the cart page section from the server ------------------ */
  function rerender() {
    var id = sectionId();
    // No cart page section here (e.g. the change came from the drawer on a
    // product page). The drawer re-renders itself on cart:refresh, so there
    // is nothing else to do. Never reload: that closes the drawer.
    if (!id) return Promise.resolve();

    return fetch(ROOT + '?section_id=' + id)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.vv-cart-section');
        var cur = document.querySelector('.vv-cart-section');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); });
  }

  /* ---- Change a line ---------------------------------------------------- */
  function change(row, quantity) {
    if (busy || !row) return;
    var key = row.getAttribute('data-key');
    if (!key) return;

    setBusy(row, true);
    showError(row, '');

    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.message || res.data.description || 'Could not update');

        // Optimistic totals before the section swaps in
        document.querySelectorAll('[data-vv-cart-subtotal],[data-vv-cart-total]').forEach(function (el) {
          el.textContent = money(res.data.total_price);
        });
        if (window.vvBus) window.vvBus.emit('cart:updated', res.data);
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        return rerender();
      })
      .catch(function (err) {
        showError(row, err.message);
        setBusy(row, false);
      })
      .then(function () { busy = false; });
  }

  /* ---- Delegated events ------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-vv-cart-qty]');
    if (step) {
      e.preventDefault();
      var row = step.closest('[data-vv-cart-item]');
      var input = row.querySelector('[data-vv-cart-qty-input]');
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-vv-cart-qty'), 10);
      if (next < 0) next = 0;
      input.value = next;
      change(row, next);
      return;
    }

    var rm = e.target.closest('[data-vv-cart-remove]');
    if (rm) {
      e.preventDefault();
      var r = rm.closest('[data-vv-cart-item]');
      change(r, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-vv-cart-qty-input]');
    if (!input) return;
    var row = input.closest('[data-vv-cart-item]');
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    change(row, q);
  });

  /* ---- Checkout button submits the real cart form ----------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"]');
    if (!btn) return;
    var form = document.getElementById('vv-cart-checkout');
    if (!form) return;
    e.preventDefault();
    form.action = ROOT + 'cart';
    var hidden = document.createElement('input');
    hidden.type = 'hidden'; hidden.name = 'checkout'; hidden.value = '1';
    form.appendChild(hidden);
    form.submit();
  });

  /* ---- Promo carousel --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-vv-promo-prev]');
    var next = e.target.closest('[data-vv-promo-next]');
    if (!prev && !next) return;
    var track = document.querySelector('[data-vv-promo-track]');
    if (!track) return;
    var card = track.querySelector('.vv-promo-card');
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20;
    var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    track.scrollBy({ left: (next ? 1 : -1) * step, behavior: 'smooth' });
  });
})();
